module.exports = __webpack_public_path__ + "c_static/img/1-1手机淘宝购物车.cdf7b60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/收藏购物车/1-1手机淘宝购物车.jpg
// module id = R/B9
// module chunks = 33